import React, { useContext, useState } from "react";
import { SiteContext } from "../App";
import "../styles/Page2.scss";

const rows = [
  {
    key: "c1",
    logo: "/images/PNS.png",
    alt: "PNS",
    link: "https://www.pns.hk/zh-hk/c/colgatecny",
  },

  {
    key: "c2",
    logo: "/images/Manning.png",
    alt: "Manning",
    link: "https://www.mannings.com.hk/zh-hant/p/942847",
  },
  {
    key: "c3",
    logo: "/images/Watson.png",
    alt: "Watson",
    link: "https://www.watsons.com.hk/c/cny_1217",
  },
  {
    key: "c4",
    logo: "/images/Wellcome.png",
    alt: "Wellcome",
    link: "https://www.wellcome.com.hk/d/lCEX3LZM0bIoNpBk.html?utm_source=URL+Link&utm_medium=WhatsApp&utm_campaign=Colgate&utm_id=47416&utm_term=Colgate&utm_content=Colgate",
  },
  {
    key: "c5",
    logo: "/images/HKTVmall.png",
    alt: "HKTVmall",
    link: "https://www.hktvmall.com/hktv/zh/%E8%AD%B7%E7%90%86%E4%BF%9D%E5%81%A5/%E8%AD%B7%E7%90%86%E4%BF%9D%E5%81%A5%E5%84%AA%E6%83%A0/%E8%81%96%E8%AA%95%E5%BF%85%E5%82%99-%E8%B2%B7%E9%AB%98%E9%9C%B2%E6%BD%94%E8%81%96%E8%AA%95%E7%89%99%E8%86%8F%E9%80%81%E8%8F%B2%E6%9E%97%E7%9B%B8%E6%A9%9F/main/search?page=0&q=%3Ahotpick%3Acategory%3ABB11000064961%3Azone%3Apersonalcarenhealth%3Astreet%3Amain%3A",
  },
];

const Page2 = () => {
  const { currentPage } = useContext(SiteContext);

  return (
    <div className="link-page-container">
      {/* 背景圖 */}
      <img src="/images/background2.jpg" alt="bkg" className="background" />

      {/* 內容疊層 */}
      <div className="content-overlay">
        {rows.map((r) => (
          <div key={r.key} className="logo-button-row">
            {/* 左側 Logo 槽位 */}
            <div className="logo-slot">
              <img src={r.logo} alt={r.alt} className="logo" />
            </div>

            {/* 右側按鈕 */}
            <a
              href={r.link}
              className="button-link"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="/images/button_link.png"
                alt="buy_link"
                className="button-img"
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Page2;
